export default "__VITE_ASSET__CqApZTBy__"